import { useQuery } from "@tanstack/react-query";
import { BriefService } from "../services/brief.service";
import { makeBriefLookUpQueryKey } from "../constants";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";

export function useLookUpByUsernameV2({
  briefId,
  platform,
  username,
}: {
  briefId: string;
  platform: string;
  username: string;
}) {
  const isValidId = Boolean(platform) && Boolean(username) && Boolean(briefId);

  const { data, isError, isFetching, error } = useQuery({
    queryKey: makeBriefLookUpQueryKey(briefId, username),
    queryFn: () =>
      BriefService.lookupByUsernameV2({ briefId, platform, username }),
    enabled: isValidId,
  });

  useEffect(() => {
    if (isError && error?.message) {
      ToastService.error(error.message);
    }
  }, [isError, error]);

  return {
    lookupData: data?.data ? data?.data[0] : undefined,
    isFetching,
  };
}
